import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import PackageDateRowFlightDetails from 'components/PackageDateRowFlightDetails';

import { PackageDateRowFlight_packageDate$key } from '__generated__/PackageDateRowFlight_packageDate.graphql';
import { PackageDateRowFlight_package$key } from '__generated__/PackageDateRowFlight_package.graphql';
import { PackageDateRowFlight_data$key } from '__generated__/PackageDateRowFlight_data.graphql';
import PackageDateRowFlightPrice from 'components/PackageDateRowFlightPrice';

type Props = {
  packageDate: PackageDateRowFlight_packageDate$key;
  package: PackageDateRowFlight_package$key;
  data: PackageDateRowFlight_data$key;
};

const PackageDateRowFlight: FC<Props> = props => {
  const packageDate = useFragment(
    graphql`
      fragment PackageDateRowFlight_packageDate on PackageDate {
        flight {
          ...PackageDateRowFlightPrice_flight
        }
        ...PackageDateRowFlightDetails_packageDate
      }
    `,
    props.packageDate
  );

  const pack = useFragment(
    graphql`
      fragment PackageDateRowFlight_package on Package {
        transportType
        externalFlights

        ...PackageDateRowFlightDetails_package
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment PackageDateRowFlight_data on Query {
        ...PackageDateRowFlightDetails_data
      }
    `,
    props.data
  );

  if (pack.transportType !== 'PLANE' || pack.externalFlights) return null;

  return (
    <>
      <PackageDateRowFlightDetails
        packageDate={packageDate}
        data={data}
        package={pack}
      />

      <PackageDateRowFlightPrice flight={packageDate.flight} />
    </>
  );
};

export default PackageDateRowFlight;
